import React from 'react';

import { observer, inject } from "mobx-react";
import { AppButton } from '../commons/button';
import { ContainerHome } from '../commons/containerHome';
import { paragrafi } from '../../assets/paragrafiHome';
import i18next from 'i18next';
import { ROUTE_FROM_UNIMODWEB, ROUTE_RESTITUZIONE_DUPLO, ROUTE_RICEVUTE, ROUTE_TRASMISSIONE } from '../../assets/frontendRouting';


@inject("rootStore")
@observer
class Home extends React.Component {

  constructor(props) {
    super(props);
    this.onClickCompilazione = this.onClickCompilazione.bind(this);
    this.qualificheStore = props.rootStore.qualificheStore;
    this.menuStore = props.rootStore.menuStore;
    this.routingStore = props.rootStore.routingStore;
    this.tipoPratica = this.qualificheStore.tipoPratica;
    
  }


  componentDidMount() {
     
  }

  componentWillUnmount() { }

  onClickCompilazione() {
    window.open(process.env.LINK_COMPILAZIONE, '_blank');
  }


  render() {
      
    const tipoPratica = this.tipoPratica
    const menuItems = this.menuStore.menuItems
    console.log( JSON.stringify(menuItems) + "menuItems")
    const paginaHome = tipoHome => {
      switch (tipoHome) {
        case 'MP':
          return (<div className="container-fluid py-3 py-md-4">

            <div className='row'>
              <div className='col-sm-12 col-md-6'>
                <ContainerHome paragrafo={paragrafi.trasmissionePegnoNonPossessorio}></ContainerHome>
              </div>
              <div className='col-sm-12 col-md-6'>
                <ContainerHome paragrafo={paragrafi.ricevutePegnoNonPossessorio}></ContainerHome>
                <ContainerHome paragrafo={paragrafi.compilazionePegnoNonPossessorio}></ContainerHome>
              </div>
              <div className='col mb-4'>
                <ContainerHome paragrafo={paragrafi.assistenzaPegno}></ContainerHome>
              </div>
            </div>

          </div>)
        case 'UN':
          
          return (<div className="container-fluid py-3 py-md-4">

           
            <div className='row'>
             
              
              <div className='col-sm-12 col-md-6'>
                { menuItems.some(item => item.label === "Trasmissione") && 
                <><ContainerHome paragrafo={paragrafi.trasmissioneMUI}></ContainerHome> 
                <AppButton onClick = {() => this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB}${ROUTE_TRASMISSIONE}`)}  titleKey={"Effettua una trasmissione"} /> 
                </>} 
                

              </div>
              
              
              <div className='col-sm-12 col-md-6'>
              { menuItems.some(item => item.label === "Ricevute") && <><ContainerHome paragrafo={paragrafi.ricevuteMUI}></ContainerHome>
               <AppButton onClick = {() => this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB}${ROUTE_RICEVUTE}`)}  titleKey={"Visualzza le ricevute"} /> 
               </>
                } 
                  

              </div>

            </div>
            
          
          {//this.qualificheStore.qualifica.identificativoProfilo === '10055' &&
            <div className='row'>
              <div className='col-sm-12 col-md-6 pt-2'>
                <ContainerHome paragrafo={paragrafi.compilazioneMUI}></ContainerHome>
              </div>
            <div className='col-sm-12 col-md-6 pt-2'>
            {menuItems.some(item => item.label === "Richiesta di restituzione del duplo") && <><ContainerHome paragrafo={paragrafi.restituzioneDuplo}></ContainerHome>
             <AppButton onClick = {() => this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB}${ROUTE_RESTITUZIONE_DUPLO}`)}  titleKey={"Esegui una richiesta"} /> 
             </>} 
              
            
            </div>
            </div>

            
           }

            <div className='row'>
                {/*
              <div className='col-sm-12 col-md-6 pt-2'>
                <ContainerHome paragrafo={paragrafi.compilazioneMUI}></ContainerHome>
              </div>
                */} 
              <div className='col-sm-12 col-md-6 pt-2'>
              <ContainerHome paragrafo={paragrafi.assistenzaMUI}></ContainerHome>
            </div>
            </div> 
            </div>
          
         )
         case 'CP':
          return (<div className="container-fluid py-3 py-md-4">

            <div className='row'>
              <div className='col-sm-12 col-md-6'>
                <ContainerHome paragrafo={paragrafi.trasmissionePegnoNonPossessorioCertificati}></ContainerHome>
              </div>
              <div className='col-sm-12 col-md-6'>
                <ContainerHome paragrafo={paragrafi.ricevutePegnoNonPossessorio}></ContainerHome>
                <ContainerHome paragrafo={paragrafi.compilazionePegnoNonPossessorio}></ContainerHome>
              </div>
              <div className='col mb-4'>
                <ContainerHome paragrafo={paragrafi.assistenzaPegno}></ContainerHome>
              </div>
            </div>

          </div>)
        default:
          break;
      }

    }
    return (

      paginaHome(tipoPratica)

    )
  }
}

export default Home
export { Home }



